<template lang="pug">
.aa.j_
  article.l(ref="sectionRef")
    h1.r.q
      gear-icon
      | {{ t("settings") }}
    section.m
      h2.r.q
        server-icon
        | {{ t("app") }}
      .m
        label
          input(type="checkbox", v-model="isManualRecompilation")
          | {{ t("manual-recomp") }}
        label
          input(type="checkbox", v-model="settingValues.offlineShare")
          | {{ t("offline-link") }}
        label
          input(type="checkbox", v-model="settingValues.glowUi")
          | Glow UI
          | {{ " " }}
          span.ba {{ t("reload-required") }}

        label
          ._a.q
            translate-icon
            | {{ t("select-language") }}
          .t.b
            dropdown-select.k(
              :entries="{ English: 'en', Русский: 'ru', 中文: 'zh' }",
              v-model="locale"
            )
    section.m
      h2.r.q
        note-icon
        | {{ t("editor") }}
      .m
        label
          input(type="checkbox", v-model="settingValues.editorMinimap")
          | {{ t("show-minimap") }}
    section.m
      h2.r.q
        log-icon
        | {{ t("formatting") }}
      .o
        label
          ._a {{ t("print-width") }}
          .t.b
            input.k(type="number", v-model="settingValues.printWidth")
        label
          ._a {{ t("tab-size") }}
          .t.b
            input.k(type="number", v-model="settingValues.tabSize")
    section.m
      h2.r.q
        db-icon
        | {{ t("storage") }}
      .m
        label.ca
          ._a {{ t("npm") }}
          .t.b
            input.k(v-model="settingValues.npmPackageProvider")
        .n
          label
            input(type="checkbox", v-model="settingValues.cachePackages")
            | {{ t("cache") }}
            | {{ " " }}
            span.ba {{ t("cache-tip") }}
          div
            b {{ t("cache-size") }}:
            | {{ " " }}
            | {{ cacheSize }}
          Button.da(@click="onClearCache")
            delete-icon
            | {{ t("clear-cache") }}
</template>

<script setup lang="ts">import { shallowRef as _shallowRef } from 'vue';

// input npm cdn
// [ ] cache remote packages offline (so you can use the app offline)
// button (clear persistent cache)

import Button from "@/components/MenuBar/Button.vue";

import DeleteIcon from "octicons:trash";
import GearIcon from "octicons:gear";
import ServerIcon from "octicons:server";
import NoteIcon from "octicons:note";
import LogIcon from "octicons:log";
import DbIcon from "octicons:database";
import TranslateIcon from "@/assets/icons/translate.svg";

import DropdownSelect from "@/components/UI/DropdownSelect.vue";

import { getAllSettings, getSetting, setSettings } from "@/settings";
import { watch, onMounted, shallowRef, reactive } from "vue";

import { useI18n } from "petite-vue-i18n";
import { useScreen } from "@/composition/useScreen";

import { isManualRecompilation } from "@/components/InfoBar/InfoBar.vue";
import { clearCache, getCacheSize } from "@/storage2";

const { t, locale } = useI18n();

let cacheSize = _shallowRef<string>("");
const updateCacheSize = () =>
  getCacheSize().then(bytes => (cacheSize.value = `${(bytes / 1024).toFixed(2)} Kb`));

updateCacheSize();

const settingValues = reactive(getAllSettings());
watch(settingValues, () => setSettings(settingValues));

watch(locale, () => setSettings({ lang: locale.value }));

const screen = useScreen();

watch(
  () => settingValues.editorMinimap,
  async v => {
    const enabled = v && screen.w > 500;

    const { getEditor } = await import("@/editor");

    getEditor().updateOptions({
      minimap: {
        enabled,
      },
    });
  }
);

watch(
  () => settingValues.tabSize,
  async s => {
    console.log("tab update", s);

    const { getEditor, getModel } = await import("@/editor");

    getEditor().updateOptions({
      tabSize: s,
    });

    getModel().updateOptions({ tabSize: s });
  }
);

const onClearCache = async () => {
  await clearCache();
  updateCacheSize();
  alert(t("cache-cleared-alert"));
};
</script>

<style lang="less" module>
.muted {
  color: rgba(160, 160, 160, 0.85);
}

.options {
  max-width: 50ch;
  // same as for export modal
  // font-size: 1.25rem;
}

.cdn-input {
  align-self: stretch;
}

.clear-cache-btn {
  --accent-rgb: 255, 40, 40;

  justify-self: start;
}
</style>
